import React from "react";
import { Fieldset } from "primereact/fieldset";
import { InputTextarea } from "primereact/inputtextarea";
import { InputText } from "primereact/inputtext";
import { Image } from "primereact/image";

const RevisarEntidad = (props) => {
  const { solicitud, croquis } = props;
  return (
    <>
      <div className="card">
        <form>
          <Fieldset legend="Datos de la organización">
            <div className="grid ">
              <div className="flex align-items-center col-12 md:col-4">
                <label
                  htmlFor="tipoCaja"
                  className="mr-2"
                  style={{ minWidth: "100px", textAlign: "left" }}
                >
                  Tipo de caja:
                </label>
                <div className="col">
                  <InputText
                    id="tipoCaja"
                    name="tipoCaja"
                    disabled
                    value={solicitud?.nomCatTipoCaja ?? ""}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="flex align-items-center col-12 md:col-4">
                <label
                  htmlFor="tipoCaja"
                  className="mr-2"
                  style={{ minWidth: "100px", textAlign: "left" }}
                >
                  Tipo de vínculo común
                </label>
                <div className="col">
                  <InputText
                    id="tipoVinculo"
                    name="tipoVinculo"
                    disabled
                    value={solicitud?.nomVinculoComun ?? ""}
                    style={{ width: "100%" }}
                  />
                </div>
              </div>
            </div>
          </Fieldset>
          <div className="p-3 "></div>
          <Fieldset legend="Domicilio Legal">
            <div className="grid">
              <div className="field col-12 md:col-4">
                <div className="flex align-items-center col-12 md:col-12">
                  <label
                    htmlFor="provincia"
                    className="mr-2"
                    style={{ minWidth: "100px", textAlign: "left" }}
                  >
                    Provincia:
                  </label>
                  <div className="col">
                    <InputText
                      id="provincia"
                      name="provincia"
                      value={solicitud?.nomAmbGeoProvincia ?? ""}
                      disabled
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
                <div className="flex align-items-center col-12 md:col-12">
                  <label
                    htmlFor="canton"
                    className="mr-2"
                    style={{ minWidth: "100px", textAlign: "left" }}
                  >
                    Cantón:
                  </label>
                  <div className="col">
                    <InputText
                      id="canton"
                      name="canton"
                      value={solicitud?.nomAmbGeoCanton ?? ""}
                      disabled
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>

                <div className="flex align-items-center col-12 md:col-12">
                  <label
                    htmlFor="parroquia"
                    className="mr-2"
                    style={{ minWidth: "100px", textAlign: "left" }}
                  >
                    Parroquia:
                  </label>
                  <div className="col">
                    <InputText
                      id="parroquia"
                      name="parroquia"
                      value={solicitud?.nomAmbGeoParroquia ?? ""}
                      disabled
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
                <div className="flex justify-content-center">
                  {croquis?.bytesArchivo && (
                    <Image
                      src={"data:image/jpeg;base64, " + croquis?.bytesArchivo}
                      zoomSrc={"data:image/jpeg;base64, " + croquis?.bytesArchivo}
                      alt="Croquis"
                      width="150"
                      height="100"
                      preview
                    />
                  )}
                </div>
              </div>
              <div className="field col-12 md:col-8">
                <div className="flex align-items-center col-12 md:col-12">
                  <label
                    htmlFor="callePrincipal"
                    className="mr-2"
                    style={{ minWidth: "110px", textAlign: "left" }}
                  >
                    Calle principal:
                  </label>
                  <div className="col">
                    <InputTextarea
                      id="callePrincipal"
                      name="callePrincipal"
                      rows={2}
                      value={solicitud?.nomCallePrincipal ?? ""}
                      disabled
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
                <div className="flex align-items-center col-12 md:col-12">
                  <label
                    htmlFor="calleSecundaria"
                    className="mr-2"
                    style={{ minWidth: "110px", textAlign: "left" }}
                  >
                    Calle secundaria:
                  </label>
                  <div className="col">
                    <InputTextarea
                      id="calleSecundaria"
                      name="calleSecundaria"
                      rows={2}
                      value={solicitud?.nomCalleSecundaria ?? ""}
                      disabled
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
                <div className="flex align-items-center col-12 md:col-5">
                  <label
                    htmlFor="numero"
                    className="mr-2"
                    style={{ minWidth: "110px", textAlign: "left" }}
                  >
                    Número:
                  </label>
                  <div className="col">
                    <InputText
                      id="numero"
                      name="numero"
                      value={solicitud?.txtNumero ?? ""}
                      disabled
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
                <div className="flex align-items-center col-12 md:col-12">
                  <label
                    htmlFor="referencia"
                    className="mr-2"
                    style={{ minWidth: "110px", textAlign: "left" }}
                  >
                    Referencia:
                  </label>
                  <div className="col">
                    <InputTextarea
                      id="referencia"
                      name="referencia"
                      rows={3}
                      disabled
                      value={solicitud?.txtReferencia ?? ""}
                      style={{ width: "100%" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </Fieldset>
        </form>
      </div>
    </>
  );
};
export default RevisarEntidad;
